module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-28.0dd44c7d.png";